import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { ICON_STRIP_BASE_CLASSNAME } from './Constants';
import { createIconStrip } from './IconStrip';
createComponents(".".concat(ICON_STRIP_BASE_CLASSNAME), createIconStrip, NO_PATTERN_BUSINESS_LOGIC);
